import { CIcon } from '~/icons/types'

export const ciBoatTrailer: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.284 14.498H12.762a2.52 2.52 0 0 0-.47-.977h2.465c3.312 0 6.323-1.659 7.493-4.128l.794-1.679A.5.5 0 0 0 22.592 7H.502a.5.5 0 0 0-.487.616l1.307 5.52a.5.5 0 0 0 .486.385h2.358a2.52 2.52 0 0 0-.47.977H.503a.5.5 0 0 0 0 1H3.67a2.539 2.539 0 0 0 4.56 1.078 2.54 2.54 0 0 0 4.56-1.078h7.967v1.626a.5.5 0 0 0 1 0v-1.626h1.528a.5.5 0 0 0 0-1Zm-22.15-6.5h20.668l-.456.965c-1.007 2.127-3.656 3.556-6.59 3.556H2.205l-1.07-4.521Zm7.136 5.521-.041.049c-.012-.017-.027-.032-.04-.049h.08Zm-2.092 3.1a1.552 1.552 0 1 1 1.433-.956 1.553 1.553 0 0 1-1.433.961v-.005Zm4.1 0a1.553 1.553 0 1 1 1.099-.453c-.29.292-.685.457-1.096.458l-.003-.005Z',
      fill: 'currentColor'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boat-trailer',
  type: 'thin'
}
